import React from "react";
import { ProjectTitle, SectionDivider, Container, Title, ProjectCard, CardShadow, ProjectContainer } from './ProjectStyles';
import tictactoe from '../tictactoe.png'
import robot from '../RobotC.png'
import arrayvisualizer from '../ArrayVisual.png'
import stocks from '../stocks.png'
import opencvimage from '../opencvimage.png'
import bikelockframe from '../bikelockframe.png'

const Project = () => {
    return (
        <div id="projects">
            <SectionDivider />
            <Container style={{}}>
                <Title>Projects</Title>
                <br /><br />
                <ProjectContainer>
                    <ProjectCard>
                        <ProjectTitle style={{color: 'white'}}>Stock Investment Porfolio</ProjectTitle>
                        <CardShadow />
                    </ProjectCard>
                    <ProjectCard>
                        <ProjectTitle style={{color: 'white'}}>Automated Robot Maze Solver</ProjectTitle>
                        <CardShadow />
                    </ProjectCard>
                    <ProjectCard>
                        <ProjectTitle style={{color: 'white'}}>Sorting Algorithm Visualizer</ProjectTitle>
                        <CardShadow />  
                    </ProjectCard>
                    <ProjectCard>
                        <ProjectTitle style={{color: 'white'}}>Face Detector</ProjectTitle>
                        <CardShadow />
                    </ProjectCard>
                    <ProjectCard>
                        <ProjectTitle style={{color: 'white'}}>Bike Frame & Lock Prototype</ProjectTitle>
                        <CardShadow />
                    </ProjectCard>
                    <ProjectCard>
                        <ProjectTitle style={{color: 'white'}}>Tic Tac Toe</ProjectTitle>
                        <CardShadow />  
                    </ProjectCard>
                </ProjectContainer>
            </Container>
        </div>
    )
};

export default Project;
